import React, { useEffect, useState } from "react";
import Model from "../Model";
import tw from "tailwind-styled-components";
import * as Yup from "yup";
import Loading from "../Loading";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useFormik } from "formik";
import { InputGroup, Label, SubmitBtn } from "../Styles/InputStyles";

const validationSchema = Yup.object().shape({
  // email: Yup.string().email("Invalid email").required("Email is required"),
  // password: Yup.string()
  //   .min(8, "Password must be at least 8 characters")
  //   .matches(/[A-Za-z]/, "Password must contain at least one letter")
  //   .matches(/[0-9]/, "Password must contain at least one number")
  //   .required("Password is required"),
  // client: Yup.string().required("Client selection is required"),
  mobile: Yup.string().required("Mobile is required"),
});

const Register = ({
  onMutateRegister,
  isRegisterLoading,
  setRegisterUser,
  apiData,
  setSelectedData,
}) => {
  const initialValues = {
    // email: "",
    // password: "",
    // client: "",
    mobile: "",
    type: "",
    userType: "landlord",
  };

  const [clientOptions, setClientOptions] = useState([]);

  useEffect(() => {
    if (apiData) {
      setClientOptions(
        apiData.map((client) => ({ id: client.id, name: client.name }))
      );
    }
  }, [apiData]);

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      onMutateRegister(values);
      setSubmitting(false);
    },
  });

  return (
    <Model width="w-11/12 max-w-md" setOpenModel={setRegisterUser}>
      {isRegisterLoading ? (
        <div className="w-full h-full">
          <Loading />
        </div>
      ) : (
        <FormWrapper>
          <Title>Equaro Registration</Title>
          <Subheading>
            Create an account to start managing your tasks.
          </Subheading>

          <form onSubmit={formik.handleSubmit}>
            {/* <div>
              <Label htmlFor="email">Email</Label>
              <Input
                name="email"
                type="email"
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.email && formik.errors.email && (
                <ErrorText>{formik.errors.email}</ErrorText>
              )}
            </div> */}

            {/* <div>
              <Label htmlFor="password">Password</Label>
              <Input
                name="password"
                type="password"
                value={formik.values.password}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
              {formik.touched.password && formik.errors.password && (
                <ErrorText>{formik.errors.password}</ErrorText>
              )}
            </div> */}

            {/* <div>
              <Label htmlFor="client">Client</Label>
              <Select
                className="w-full pl-2 mt-1 rounded-lg"
                name="client"
                value={formik.values.client}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              >
                <MenuItem value="" disabled>
                  Select a client
                </MenuItem>
                {clientOptions.map((client) => (
                  <MenuItem key={client.id} value={client.id}>
                    {client.name}
                  </MenuItem>
                ))}
              </Select>
              {formik.touched.client && formik.errors.client && (
                <ErrorText>{formik.errors.client}</ErrorText>
              )}
            </div> */}

            <FormWrapper>
              <InputGroup>
                <Label htmlFor="mobile">Mobile</Label>
                <Input
                  name="mobile"
                  type="mobile"
                  value={formik.values.mobile}
                  onChange={(e) => {
                    const { value } = e.target;
                    if (/^\d{0,10}$/.test(value)) {
                      formik.handleChange(e);
                    }
                  }}
                  onBlur={formik.handleBlur}
                />
                {formik.touched.mobile && formik.errors.mobile && (
                  <ErrorText>{formik.errors.mobile}</ErrorText>
                )}
              </InputGroup>
              <InputGroup>
                <Label htmlFor="type">Type</Label>
                <Select
                  className="w-full pl-2 mt-1 rounded-lg"
                  name="type"
                  value={formik.values.type}
                  onChange={formik.handleChange}
                  // onBlur={formik.handleBlur}
                >
                  <MenuItem value="Individual">Individual</MenuItem>
                  <MenuItem value="Co-living/PG Operator">Co-living/PG Operator</MenuItem>
                </Select>
                {formik.touched.type && formik.errors.type && (
                  <ErrorText>{formik.errors.type}</ErrorText>
                )}
              </InputGroup>
            </FormWrapper>

            <BtnWrapper>
              <SubmitBtn type="submit" disabled={formik.isSubmitting}>
                Register
              </SubmitBtn>
            </BtnWrapper>
          </form>
        </FormWrapper>
      )}
    </Model>
  );
};

// const Label = tw.label`block text-sm font-medium text-gray-700 mb-1`;
const Input = tw.input`truncate border border-gray-300 border-m rounded pl-2 focus:ring-1 focus:ring-sky-600 focus:border-sky-600 focus:outline-none duration-200`;
const Button = tw.button`w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary-color hover:bg-hover-color focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50`;
const ErrorText = tw.div`text-red-500 text-sm mt-1`;
const Title = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
const HeadingWrapper = tw.div`text-center mb-4`;
const Heading = tw.h1`text-3xl font-extrabold text-gray-900`;
const Subheading = tw.p`text-sm text-center text-gray-600`;
const FormWrapper = tw.div`px-1  space-y-3 `;
const BtnWrapper = tw.div`w-full flex items-center justify-center space-x-10 mt-8`;

export default Register;
